<template>
    <div id="main">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('novo-sub-grupo-produto') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" tag="button" @click="voltar">
                    {{ $t('voltar') }}
                </button>
                <button class="save-btn" type="button" @click="saveSubGrupoPergunta">
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="form-columns-fit mt-5">
            <div class="columns is-flex-wrap">
                <div class="column is-12">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="'idErp'"
                                ref="idErpInput"
                                v-model="sgp.idsubgrupoprodutoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!sgp.idsubgrupoprodutoerp"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                v-model="sgp.descricao"
                                :id="'descricao'"
                                :placeholder="'descricao-do-sub-grupo-placeholder'"
                                :maxlength="50"
                                title="descricao-do-sub-grupo-produto"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!sgp.descricao"
                                ref="descricaoInput"
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                id="grupo"
                                ref="gpSelect"
                                title="grupo-sub-grupo-produto"
                                v-model="grupo"
                                :placeholder="'grupo-do-sub-grupo-placeholder'"
                                required
                                disabled
                                tooltipLabel="info-grupo-subgrupoproduto"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubGrupoProdutoService from '@/services/SubGrupoProdutoService';
import SubGrupoValidation from '@/services/validations/SubGrupoValidation';
import Message from '@/models/Message';

export default {
    props: {
        grupo: {},
    },
    data() {
        return {
            isSaving: false,
            sgp: {
                situacao: 1,
                grupoproduto: null,
                nomeunico: null,
            },
            msgs: [],
            validation: null,
        };
    },
    created() {
        this.service = new SubGrupoProdutoService(this.$http, this.$router);
        this.validation = new SubGrupoValidation(this.msgs);
    },

    methods: {
        voltar() {
            this.$emit('fecharModal', 'subgrupo-produto', 'close', 1);
        },
        saveSubGrupoPergunta() {
            this.isSaving = true;
            this.sgp.grupoproduto = {
                idgrupoproduto: this.grupo.id,
            };
            this.sgp = this.mapTosave(this.sgp);
            if (this.validation.validate(this.sgp, this.$refs)) {
                this.service
                    .save(this.sgp)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-subgrupo-produto-salvo';
                            this.sgp = body.content;
                            this.msgs.push(new Message('success', msg, true));

                            setTimeout(() => {
                                this.$emit('fecharModal', 'subgrupo-produto', 'save', 1);
                            }, 1000);
                        } else {
                            if (this.$te(body.message)) {
                                let message = body.message;
                                if (message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(message, { n: this.sgp.idsubgrupoprodutoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            } else {
                this.isSaving = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px !important;
    background-color: $sovis-white;
}
</style>
